import * as React from 'react';
import { classnames } from '@src/utils/classnames';
import { GroupBase } from 'react-select';
import { IOptionBase, ISelectPlaceholderProps } from '../models';
import styled from './SelectPlaceholder.scss';

export const SelectPlaceholder = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>({
  selectProps,
  children,
  innerProps,
}: React.PropsWithChildren<ISelectPlaceholderProps<OptionType, GroupType, IsMulti>>) => {
  const { classNamePrefix } = selectProps;
  const classes = classnames(styled.root, classNamePrefix);

  return (
    <div className={classes} {...innerProps}>
      {children}
    </div>
  );
};
